export const SEND_CONTACT_MESSAGE_MUTATION = gql`
  mutation SendContactMessage($input: ContactInput!) {
    sendContactMessage(input: $input)
  }
`;
